// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__5z6Lq","TableStyled":"Table_TableStyled__6O7r_","TableCell":"Table_TableCell__mUYv4"};